import { Stack, SxProps, TableCell, TableRow, Theme } from '@mui/material';

import { Spinner } from '../loading-screen';

export default function TableSpinner({ colSpan, sx }: { colSpan: number; sx?: SxProps<Theme> }) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan}>
        <Stack flexGrow={1} alignItems="center" justifyContent="center" sx={{ py: 20, ...sx }}>
          <Spinner />
        </Stack>
      </TableCell>
    </TableRow>
  );
}
